import { MUTATIONS, STATE } from "./names";
import type { State } from "./types";

export default {
    [MUTATIONS.SET_NOTIFICATIONS_BAR_OPEN](state: State, value: boolean) {
        state[STATE.NOTIFICATIONS_BAR_OPEN] = value;
    },
}